import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function RefundPolicy() {
  return (
    <div
      className="min-h-screen font-sans"
      style={{ backgroundColor: "#FEF7EB" }}
    >
      <Navbar />
      <section className="pt-40 pb-24 px-6 md:px-16">
        <div className="max-w-3xl mx-auto">
          <p
            className="text-xs font-semibold uppercase tracking-widest mb-4"
            style={{ color: "#0073E5" }}
          >
            Legal
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Refund Policy
          </h1>
          <p className="text-sm text-gray-400 mb-10">
            Last updated: April 14, 2026
          </p>
          <div className="space-y-8 text-gray-600 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                1. General Policy
              </h2>
              <p>
                This Refund Policy outlines the conditions under which London
                App Syndicate LTD ("Company", "we", "our", or "us") may provide
                refunds for payments made for services offered through this
                website (the "Site").
              </p>
              <p className="mt-2">
                We aim to provide high-quality services and fair treatment to
                all users. Refunds are considered in accordance with the terms
                set out below.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                2. Eligibility for Refund
              </h2>
              <p>Refunds may be granted under the following conditions:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  A payment was made directly through the Company (e.g., via the
                  Site using a valid payment method)
                </li>
                <li>
                  A verified issue occurred that materially affected the
                  delivery of the service
                </li>
                <li>
                  The refund request is submitted within 14 days of the original
                  payment date
                </li>
              </ul>
              <p className="mt-2">
                Refunds are not guaranteed and are assessed on a case-by-case
                basis.
              </p>
              <p className="mt-2">
                Refunds will generally not be granted in the following
                situations:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Change of mind or general dissatisfaction</li>
                <li>Failure to use the service</li>
                <li>User error or misunderstanding of the service</li>
                <li>
                  Issues caused by third-party services or external factors
                  beyond our control
                </li>
                <li>Requests submitted after the applicable refund period</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                3. Refund Request Process
              </h2>
              <p>To request a refund, you must contact our support team:</p>
              <p className="mt-2">Email: support@londonappsco.com</p>
              <p>Phone: +447520663996</p>
              <p className="mt-2">Your request should include:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Full name and contact details</li>
                <li>
                  Proof of payment (date, amount, and transaction reference if
                  available)
                </li>
                <li>Description of the issue or reason for the request</li>
              </ul>
              <p className="mt-2">
                We may request additional information to verify your claim.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                4. Review and Approval
              </h2>
              <p>All refund requests are reviewed individually.</p>
              <p className="mt-2">The Company reserves the right to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Approve or decline a refund request</li>
                <li>Request additional documentation</li>
                <li>Determine whether the issue qualifies under this Policy</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                5. Processing of Refunds
              </h2>
              <p>If a refund is approved:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  The refund will be issued using the original payment method
                  where possible
                </li>
                <li>
                  Processing time may take 5–14 business days, depending on the
                  payment provider
                </li>
                <li>
                  Any applicable fees or taxes may be included where required by
                  law
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                6. Cancellations
              </h2>
              <p>If the Company offers services that can be cancelled:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Cancellation prevents future charges (if applicable)</li>
                <li>
                  Cancellation does not automatically entitle the user to a
                  refund
                </li>
              </ul>
              <p className="mt-2">
                Refunds remain subject to the conditions outlined in this
                Policy.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                7. Limitation of Liability
              </h2>
              <p>The Company is not responsible for:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  Issues caused by user devices, software, or internet
                  connectivity
                </li>
                <li>Interruptions caused by third-party services</li>
                <li>Factors outside the Company's reasonable control</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                8. Changes to this Policy
              </h2>
              <p>
                We reserve the right to modify this Refund Policy at any time.
              </p>
              <p className="mt-2">
                Updated versions will be posted on this page with a revised
                effective date. Continued use of the Site constitutes acceptance
                of the updated Policy.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                9. Contact Information
              </h2>
              <p>London App Syndicate LTD</p>
              <p>International House</p>
              <p>22-28 Wood Street</p>
              <p>Doncaster</p>
              <p>England</p>
              <p>DN1 3LW</p>
              <p className="mt-2">Email: support@londonappsco.com</p>
              <p>Phone: +447520663996</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
